import { LayoutBadge } from './layout-badge';
import {
    layoutPortraitBorderStyle,
    layoutPortraitGridStyle,
    layoutPortraitTabStyle
} from './layout-portrait.styles.css';
import { fontGroups } from '@zoopla-eng/zds/themes';
import { PropsWithChildren } from 'react';

export type LayoutPortraitProps = {
    type?: 'featured' | 'premium';
};

const LayoutPortrait: React.FC<PropsWithChildren<LayoutPortraitProps>> = ({
    type,
    children
}) => {
    return (
        <div
            className={`${layoutPortraitBorderStyle({ type })} ${
                fontGroups.plate
            }`}
        >
            {type ? (
                <div className={layoutPortraitTabStyle({ type })}>
                    <LayoutBadge type={type} />
                </div>
            ) : null}
            <div className={layoutPortraitGridStyle({ type })}>{children}</div>
        </div>
    );
};

export { LayoutPortrait };
